var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActiveActivities(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.333 1.833h-.002a.66.66 0 0 1-.568-.327 2.051 2.051 0 0 0-3.53 0A.66.66 0 0 1 6 1.74m4.333.092L6 1.741m4.333.092h3.333a.5.5 0 0 1 .5.5V15a.5.5 0 0 1-.5.5H2.333a.5.5 0 0 1-.5-.5V2.333a.5.5 0 0 1 .5-.5h3.343A.66.66 0 0 0 6 1.741m4.333.092L6 1.741m3.72 12.758a2.166 2.166 0 0 0 1.647-.756l1.28-1.494c.335-.393.52-.892.52-1.409V3.667a.834.834 0 0 0-.834-.834H3.666a.833.833 0 0 0-.589.244l.354.354-.354-.354a.833.833 0 0 0-.244.59v9.999a.833.833 0 0 0 .833.833H9.72Zm0 0V14v.5Z",
    fill: "#0078D4",
    stroke: "#0078D4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.833 5.775-2.59 3.453a.166.166 0 0 1-.251.018l-1.21-1.21A.834.834 0 1 0 4.6 9.214l1.44 1.441c.292.29.686.454 1.097.454.037 0 .073 0 .11-.004a1.547 1.547 0 0 0 1.133-.618l2.785-3.712a.833.833 0 1 0-1.334-1h.002Z",
    fill: "#0078D4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveActivities);
export default __webpack_public_path__ + "static/media/active_activities.a9ddd42e.svg";
export { ForwardRef as ReactComponent };